import { render, staticRenderFns } from "./custom-native-smart-banner.vue?vue&type=template&id=51a8b1e4&scoped=true&"
import script from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
export * from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
import style0 from "./custom-native-smart-banner.vue?vue&type=style&index=0&id=51a8b1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8b1e4",
  null
  
)

export default component.exports